import { Switch, SwitchProps } from '@mui/material'
import React from 'react'

export const BaseSwitch: React.FC<SwitchProps> = (props) => <Switch {...props} />
